import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpService } from "../http.service";
import { ServiceBase } from "../servicebase";
import { JobTitleSeniorizationModel } from "../models/hiring/jobTitleSeniorization.model";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";

@Injectable()
export class JobTitleSeniorizationService extends ServiceBase<JobTitleSeniorizationModel> {
  constructor(http: HttpService, private httpClient: HttpClient) {
    super("JobTitleSeniorization", http, environment.apiUrl);
  }

  createEntity(input: any): JobTitleSeniorizationModel {
    return JobTitleSeniorizationModel.create(input);
  }

  deactivate(id: string) {
    return this.httpClient
      .delete(`${this.baseUrl}/${this.endpoint}/exclude-seniorization/${id}`)
      .pipe(map((response) => response));
  }
}